/**
 * Módulo caja chica / gastos: listado, registro y totales en panel caja.
 */

function getAjaxUrl(win) {
	const cfg = win.POSKN_API_CONFIG || {};
	return cfg.ajaxUrl || win.ajaxurl || 'pos-ajax.php';
}

function getNonce(win) {
	return win.posNonce || (win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.posNonce) || '';
}

function escapeHtml(str) {
	return String(str || '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;');
}

function isMonedaBs(moneda) {
	const m = String(moneda || 'USD').toUpperCase();
	return m === 'BS' || m === 'Bs' || m === 'bs';
}

function initGastosAdminEvents(win, $) {
	if (win._posknGastosAdminBound) return;
	win._posknGastosAdminBound = true;

	$(document).on('click', '.btn-guardar-gasto', () => win.guardarGasto());
	$(document).on('change', '#gasto-metodo-pago', function syncGastoMoneda() {
		const currency = $(this).find('option:selected').data('currency');
		if (currency && $('#gasto-moneda').length) {
			$('#gasto-moneda').val(currency);
		}
	});
}

export function attachGastosAdminGlobals(win, $) {
	initGastosAdminEvents(win, $);

	win.mostrarListaGastos = function mostrarListaGastos(gastos) {
		const container = $('#lista-gastos');
		if (!gastos.length) {
			container.html('<p class="no-gastos">No hay movimientos registrados</p>');
			return;
		}

		let html = '<div class="gastos-tabla">';
		gastos.slice(0, 20).forEach((gasto) => {
			const tipo = gasto.tipo || 'egreso';
			const moneda = (gasto.moneda || 'USD').toUpperCase();
			const esIngreso = tipo === 'ingreso';
			const colorMonto = esIngreso ? '#28a745' : '#dc3545';
			const icono = esIngreso ? '💰' : '💸';
			const tipoTexto = esIngreso ? 'Ingreso' : 'Egreso';
			const simboloMoneda = isMonedaBs(moneda) ? 'Bs.' : '$';
			const montoFormateado = parseFloat(gasto.monto).toFixed(2);
			const metodoPagoLabel =
				gasto.metodo_pago && typeof win.formatearNombreMetodo === 'function'
					? win.formatearNombreMetodo(gasto.metodo_pago)
					: gasto.metodo_pago || '';
			const metodoPagoHtml = metodoPagoLabel
				? `<span class="gasto-metodo" title="Afecta a este método al cerrar caja">${escapeHtml(metodoPagoLabel)}</span>`
				: '';

			html += `
				<div class="gasto-item" style="border-left: 4px solid ${colorMonto};">
					<span class="gasto-tipo" style="color: ${colorMonto}; font-weight: bold;">${icono} ${tipoTexto}</span>
					${metodoPagoHtml}
					<span class="gasto-desc">${escapeHtml(gasto.descripcion)}</span>
					<span class="gasto-categoria">${escapeHtml(gasto.categoria)}</span>
					<span class="gasto-monto" style="color: ${colorMonto}; font-weight: bold;">${esIngreso ? '+' : '-'}${simboloMoneda}${montoFormateado}</span>
					<span class="gasto-fecha">${escapeHtml(gasto.fecha_formateada || new Date(gasto.fecha).toLocaleDateString())}</span>
					<button class="btn-eliminar-gasto" onclick="eliminarGasto(${gasto.id})" title="Eliminar movimiento">🗑️</button>
				</div>
			`;
		});
		html += '</div>';
		container.html(html);
	};

	win.cargarGastos = function cargarGastos() {
		$('#ingresos-hoy').text('Cargando...');
		$('#egresos-hoy').text('Cargando...');
		$('#saldo-neto').text('Cargando...');
		$('#lista-gastos').html(
			'<div style="text-align: center; padding: 20px;"><div class="loading-spinner"></div><br>Cargando movimientos...</div>',
		);

		$.ajax({
			url: getAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_obtener_gastos',
				nonce: getNonce(win),
			},
			success(response) {
				if (response && response.success) {
					const gastos = response.data.gastos || [];
					const hoy = new Date().toDateString();
					let ingresosHoyUsd = 0;
					let ingresosHoyBs = 0;
					let egresosHoyUsd = 0;
					let egresosHoyBs = 0;

					gastos.forEach((gasto) => {
						const fechaGasto = new Date(gasto.fecha).toDateString();
						const monto = parseFloat(gasto.monto);
						const tipo = gasto.tipo || 'egreso';
						const moneda = gasto.moneda || 'USD';
						if (fechaGasto !== hoy) return;
						if (tipo === 'ingreso') {
							if (isMonedaBs(moneda)) ingresosHoyBs += monto;
							else ingresosHoyUsd += monto;
						} else if (isMonedaBs(moneda)) egresosHoyBs += monto;
						else egresosHoyUsd += monto;
					});

					const saldoNetoUsd = ingresosHoyUsd - egresosHoyUsd;
					const saldoNetoBs = ingresosHoyBs - egresosHoyBs;

					$('#ingresos-hoy').html(
						`$${ingresosHoyUsd.toFixed(2)}<br><small style="color: #666;">Bs. ${ingresosHoyBs.toFixed(2)}</small>`,
					);
					$('#egresos-hoy').html(
						`$${egresosHoyUsd.toFixed(2)}<br><small style="color: #666;">Bs. ${egresosHoyBs.toFixed(2)}</small>`,
					);
					$('#saldo-neto').html(
						`$${saldoNetoUsd.toFixed(2)}<br><small style="color: #666;">Bs. ${saldoNetoBs.toFixed(2)}</small>`,
					);
					$('#saldo-neto').css(
						'color',
						saldoNetoUsd + saldoNetoBs >= 0 ? '#28a745' : '#dc3545',
					);
					win.mostrarListaGastos(gastos);
				} else {
					$('#ingresos-hoy').html('$0.00<br><small style="color: #666;">Bs. 0.00</small>');
					$('#egresos-hoy').html('$0.00<br><small style="color: #666;">Bs. 0.00</small>');
					$('#saldo-neto').html('$0.00<br><small style="color: #666;">Bs. 0.00</small>');
					$('#lista-gastos').html('<p class="no-gastos">Error al cargar movimientos</p>');
				}
			},
			error() {
				$('#ingresos-hoy').html('$0.00<br><small style="color: #666;">Bs. 0.00</small>');
				$('#egresos-hoy').html('$0.00<br><small style="color: #666;">Bs. 0.00</small>');
				$('#saldo-neto').html('$0.00<br><small style="color: #666;">Bs. 0.00</small>');
				$('#lista-gastos').html('<p class="no-gastos">Error de conexión</p>');
			},
		});
	};

	win.guardarGasto = function guardarGasto() {
		const tipo = $('#gasto-tipo').val();
		const moneda = $('#gasto-moneda').val();
		const descripcion = $('#gasto-descripcion').val().trim();
		const montoRaw = $('#gasto-monto').val().trim();
		const categoria = $('#gasto-categoria').val();
		const metodoPago = ($('#gasto-metodo-pago').val() || '').trim();
		const montoNum = Math.abs(parseFloat(montoRaw));

		if (!metodoPago) {
			win.mostrarNotificacion(
				'❌ Debes seleccionar un método de pago para este movimiento (ingreso suma al total, egreso resta)',
				'error',
			);
			$('#gasto-metodo-pago').focus();
			return;
		}

		if (!descripcion || !montoRaw || !categoria || !tipo || !moneda) {
			win.mostrarNotificacion('❌ Por favor completa todos los campos', 'error');
			return;
		}

		if (!Number.isFinite(montoNum) || montoNum <= 0) {
			win.mostrarNotificacion('❌ El monto debe ser mayor a 0', 'error');
			$('#gasto-monto').focus();
			return;
		}

		const submitBtn = $('.btn-guardar-gasto');

		const enviarGasto = () => {
			submitBtn.prop('disabled', true).text('Guardando...');

			$.ajax({
				url: getAjaxUrl(win),
				method: 'POST',
				dataType: 'json',
				data: {
					action: 'poskn_guardar_gasto',
					nonce: getNonce(win),
					tipo,
					moneda,
					descripcion,
					monto: montoNum,
					categoria,
					metodo_pago: metodoPago,
				},
				success(response) {
					if (response && response.success) {
						$('#form-gastos')[0].reset();
						win.cargarGastos();
						const tipoTexto = tipo === 'ingreso' ? 'Ingreso' : 'Egreso';
						win.mostrarNotificacion(`💰 ${tipoTexto} registrado correctamente`, 'success');
						if ($('#modulo-caja').is(':visible') && typeof win.cargarEstadoCaja === 'function') {
							win.cargarEstadoCaja();
						}
					} else {
						win.mostrarNotificacion(
							`❌ Error al guardar el movimiento: ${response.data || 'Error desconocido'}`,
							'error',
						);
					}
				},
				error(xhr) {
					let msg = 'Error de conexión al guardar el gasto';
					try {
						const parsed = JSON.parse(xhr.responseText);
						if (parsed && parsed.data) msg = parsed.data;
					} catch (_e) {
						/* respuesta no JSON */
					}
					win.mostrarNotificacion(`❌ ${msg}`, 'error');
				},
				complete() {
					submitBtn.prop('disabled', false).text('Guardar Movimiento');
				},
			});
		};

		if (tipo !== 'egreso') {
			enviarGasto();
			return;
		}

		submitBtn.prop('disabled', true).text('Verificando saldo...');

		$.ajax({
			url: getAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'pos_obtener_detalles_caja',
				nonce: getNonce(win),
			},
			success(response) {
				if (response && response.success) {
					const metodos = response.data.metodos_pago || {};
					const saldo = parseFloat(metodos[metodoPago] ?? 0) || 0;
					if (montoNum > saldo + 0.009) {
						const nombre =
							typeof win.formatearNombreMetodo === 'function'
								? win.formatearNombreMetodo(metodoPago)
								: metodoPago;
						const simbolo = isMonedaBs(moneda) ? 'Bs. ' : '$';
						win.mostrarNotificacion(
							`❌ Saldo insuficiente en ${nombre}. Disponible: ${simbolo}${Math.max(0, saldo).toFixed(2)}`,
							'error',
						);
						submitBtn.prop('disabled', false).text('Guardar Movimiento');
						return;
					}
				}
				enviarGasto();
			},
			error() {
				enviarGasto();
			},
		});
	};

	win.eliminarGasto = function eliminarGasto(gastoId) {
		if (!win.confirm('¿Estás seguro de que deseas eliminar este gasto?')) return;

		$.ajax({
			url: getAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_eliminar_gasto',
				nonce: getNonce(win),
				gasto_id: gastoId,
			},
			success(response) {
				if (response && response.success) {
					win.cargarGastos();
					win.mostrarNotificacion('🗑️ Gasto eliminado correctamente', 'success');
				} else {
					win.mostrarNotificacion(
						`❌ Error al eliminar el gasto: ${response.data || 'Error desconocido'}`,
						'error',
					);
				}
			},
			error() {
				win.mostrarNotificacion('❌ Error de conexión al eliminar el gasto', 'error');
			},
		});
	};

	win.cargarGastosCaja = function cargarGastosCaja() {
		$.ajax({
			url: getAjaxUrl(win),
			method: 'POST',
			dataType: 'json',
			data: {
				action: 'poskn_obtener_gastos_fecha',
				nonce: getNonce(win),
				fecha: new Date().toISOString().split('T')[0],
			},
			success(response) {
				if (!response || !response.success) return;

				const totalEgresosUsd = response.data.total_egresos_usd || 0;
				const totalEgresosBs = response.data.total_egresos_bs || 0;
				const totalIngresosUsd = response.data.total_ingresos_usd || 0;
				const totalIngresosBs = response.data.total_ingresos_bs || 0;

				$('#gastos-dia').text(`$${totalEgresosUsd.toFixed(2)}`);
				$('#gastos-dia-bs').text(`Bs. ${totalEgresosBs.toFixed(2)}`);
				$('#ingresos-caja').text(`$${totalIngresosUsd.toFixed(2)}`);
				$('#ingresos-caja-bs').text(`Bs. ${totalIngresosBs.toFixed(2)}`);

				const montoInicial =
					parseFloat($('#monto-inicial').text().replace('$', '').replace(/,/g, '')) || 0;
				const montoInicialBs =
					parseFloat($('#monto-inicial-bs').text().replace('Bs. ', '').replace(/,/g, '')) || 0;
				const ventasDia =
					parseFloat($('#ventas-dia').text().replace('$', '').replace(/,/g, '')) || 0;
				const ventasDiaBs =
					parseFloat($('#ventas-dia-bs').text().replace('Bs. ', '').replace(/,/g, '')) || 0;
				const reembolsosDia =
					parseFloat($('#reembolsos-dia').text().replace('$', '').replace(/,/g, '')) || 0;
				const tasa = win.TASA_DOLAR || 100;
				const reembolsosBs = reembolsosDia * tasa;

				const nuevoTotal =
					montoInicial + ventasDia + totalIngresosUsd - totalEgresosUsd - reembolsosDia;
				const nuevoTotalBs =
					montoInicialBs + ventasDiaBs + totalIngresosBs - totalEgresosBs - reembolsosBs;

				$('#total-caja').text(`$${nuevoTotal.toFixed(2)}`);
				$('#total-caja-bs').text(`Bs. ${nuevoTotalBs.toFixed(2)}`);
			},
		});
	};
}
